
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Global from '@/global';
import * as SearchUtils from '@/utils/search';
import * as APITypes from '@/controllers/api/types';

@Component
export default class PreviewList extends Vue {
  @Prop() private readonly title!: string;
  @Prop() private readonly sortOptions!: string[];
  @Prop() private readonly resultsCount!: number;
  @Prop() private readonly disableFilters!: boolean;
  @Prop() private readonly disableButtons: boolean | null = null;

  private page: number = 1;
  private perPageOptions: number[] = Global.perPageOptions;
  private orderOptions: string[] = this.sortOptions?.length
    ? Global.orderOptions
    : [];

  private get maxPage(): number {
    return SearchUtils.countPages(this.resultsCount, this.filters.perPage);
  }

  private filters: Global.ExtendedSearchFilters = {
    sort: this.sortOptions?.length ? this.sortOptions[0] : null,
    order: APITypes.Order.desc,
    perPage: Global.perPageOptions[0],
  };

  private filtersChange(value: Global.ExtendedSearchFilters): void {
    this.filters = value;
  }

  private pageChange(page: number): void {
    this.page = page;
  }

  @Watch('filters.perPage')
  private handlePageChange(): void {
    if (this.page > this.maxPage) this.page = this.maxPage;
  }

  @Watch('filters', { deep: true })
  @Watch('page')
  private changeData(): void {
    this.$emit('changeData', { ...this.filters, page: this.page });
  }
}
